import { Badge, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

const zIndex = 2;

export const StyledBadge = styled(Badge)<{
  $firstView: boolean;
  $isInDocsView: boolean;
}>`
  cursor: pointer;
  position: relative;
  z-index: ${props => props.$firstView && zIndex};

  ${Badge.Styled.BadgeTextual} {
    border: ${props =>
      props.$firstView
        ? '2px solid var(--text-link)'
        : props.$isInDocsView
        ? 'none'
        : '1px solid var(--border-soft)'};
    background: ${props => props.$isInDocsView && 'var(--surface-default)'};
    color: var(--text-default);

    & svg {
      fill: var(--icon-default);
    }

    ${props =>
      !props.$isInDocsView &&
      `
        color: var(--text-primary);

        & svg {
          fill: var(--icon-primary);
        }
      `};
  }
`;

export const BackDrop = styled.div`
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex};
`;

export const TooltipTitle = styled.h2`
  ${typographyV2.titleBase};
  padding-bottom: 12px;
`;

export const TooltipTextSoft = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  padding-bottom: 8px;
`;

export const TooltipText = styled.p`
  ${typographyV2.bodySm};
  padding-bottom: 8px;
`;

export const TooltipTextList = styled.ul`
  margin: 16px !important;
  list-style: disc !important;
`;

export const TooltipTextListItem = styled.li`
  ${typographyV2.bodySm};
  padding-bottom: 8px;
  padding-left: 8px;
`;
